<div class="pricing" *ngIf="showPricingModal$ | async">

	<div class="pricing--cards-container">
		<!-- STARTER PLAN -->
		<div class="pricing--card plan-starter order-1">
			<h2 class="pricing--plan-title">Starter Plan TEST</h2>
			<h3 class="pricing--plan-team">1 Project</h3>
			<p class="pricing--plan-price-details"><span>0$</span> / month</p>
			<hr class="pricing--plan-divider" />
			<ul class="pricing--plan-features">
				<li>Virtual Item Creation & NFT Minting</li>
				<li>Fully Audited Smart Contracts</li>
				<li>Mobile App Store Compliant Wallet</li>
				<li>Crypto Wallet - Non-Custodial & Custodial</li>
				<li>Multi-Platform SDK (Unity & Unreal)</li>
				<li>Community Support</li>
			</ul>

			<button
				(click)="choosePlan('starter')"
				class="pricing--plan-button action-button-dark"
			>
				<span>Get started for free</span>
			</button>
		</div>

		<!-- STUDIO PLAN -->
		<div class="pricing--card plan-studio order-2">
			<div class="pricing--ribbon">
				<p>Most popular</p>
			</div>
			<h2 class="pricing--plan-title">Studio Plan</h2>
			<h3 class="pricing--plan-team">2 Projects</h3>
			<p class="pricing--plan-price-details"><span>$9.99</span> / month</p>
			<hr class="pricing--plan-divider" />
			<p class="font-poppins text-xl mb-4">
				Everything from Starter Plan and more:
			</p>
			<ul class="pricing--plan-features compact">
				<li>500 Virtual Items</li>
				<li>500 NFT Mints</li>
				<li>Up to 250,000 copies per NFT</li>
				<li>Custom Feature Configuration</li>
				<li>Prioritized Support</li>
			</ul>

			<button
				(click)="choosePlan('studio')"
				class="pricing--plan-button action-button"
			>
				<span>Choose Plan</span>
			</button>
		</div>

		<!-- PRO PLAN -->
		<div class="pricing--card plan-pro order-3">
			<h2 class="pricing--plan-title">Pro Plan</h2>
			<h3 class="pricing--plan-team">Unlimited Projects</h3>

			<p class="pricing--plan-price-details">Contact us for billing options</p>
			<hr class="pricing--plan-divider" />
			<p class="font-poppins text-xl mb-4">
				Everything from Studio Plan and more:
			</p>
			<ul class="pricing--plan-features compact">
				<li>Unlimited Virtual Items</li>
				<li>Unlimited NFT Mints</li>
				<li>Unlimited copies per NFT</li>
				<li>Direct Support & Communication Channel</li>
				<li>Custom Feature Development</li>
				<li>P2P NFT Marketplace</li>
				<li>Advanced Feature Access</li>
			</ul>

			<button
				(click)="choosePlan('pro')"
				class="pricing--plan-button action-button-violet"
			>
				<span>Contact us</span>
			</button>
		</div>
	</div>
	<div class="pricing--skip-button-container">
		<button (click)="skipPricing()" class="pricing--skip-button">
			<span>Skip for now</span>
			<p class="text-sm text-borderGray">
				You will have limited access to features
			</p>
		</button>
	</div>
</div>
